export const SET_CONTACTS = (state, payload) => (state.items = payload);
